// sections/Works.jsx
import React from "react";
import { projects } from "../constants";

const Works = () => {
  // helper to normalize hrefs
  const normalizeHref = (href) => {
    if (!href) return null;
    const trimmed = href.trim();
    if (trimmed === "#" || trimmed === "") return null;
    if (/^(https?:|mailto:|\/)/i.test(trimmed)) return trimmed;
    return `https://${trimmed}`;
  };

  return (
    <section id="work" className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-6xl mx-auto text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
            Selected Work
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Projects I’ve built with care, designed to solve real problems.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project) => {
            const link = normalizeHref(project.href);

            return (
              <div
                key={project.id}
                className="bg-gray-50 p-0 text-center hover:bg-black hover:text-white transition-all duration-300 group rounded overflow-hidden shadow"
              >
                {/* Clickable screenshot */}
                {link ? (
                  <a
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="relative block"
                    aria-label={`Open ${project.name} in new tab`}
                  >
                    <img
                      src={project.image}
                      alt={`${project.name} screenshot`}
                      className="w-full h-48 object-cover transform transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 flex items-end justify-center">
                      <div className="w-full bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-4">
                        <div className="flex items-center justify-between text-white">
                          <span className="text-sm font-semibold">
                            View live
                          </span>
                          <span className="text-xs opacity-80">
                            Open in new tab ↗
                          </span>
                        </div>
                      </div>
                    </div>
                  </a>
                ) : (
                  <div className="relative block">
                    <img
                      src={project.image}
                      alt={`${project.name} screenshot`}
                      className="w-full h-48 object-cover rounded-t-md"
                      loading="lazy"
                    />
                  </div>
                )}

                {/* Project info */}
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-1">{project.name}</h3>
                  <p className="text-sm text-gray-500 mb-3 group-hover:text-gray-300">
                    {project.description}
                  </p>
                  <div className="flex justify-center flex-wrap gap-2 text-xs uppercase text-gray-400 group-hover:text-gray-300">
                    {project.frameworks.map((fw) => (
                      <span key={fw.id}>{fw.name}</span>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Works;
